import apiClient from '../apiClient';
import { DELETE_ACCOMODATION_ITEM_URL } from '../apiUrl';

const deleteAccomodationItemApi = Id => {
  return apiClient.delete(DELETE_ACCOMODATION_ITEM_URL(Id));
};

export default deleteAccomodationItemApi;
